import axios from 'axios';
import { getApiUrl } from '../config/config';
export * from './dashboard';

const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
api.interceptors.response.use(
  (response) => response.data,
  async (error) => {
    const originalRequest = error.config;

    // If the error is 401 and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const { refreshToken } = await import('../services/auth');
        const result = await refreshToken();
        
        if (!result) {
          throw new Error('Token refresh failed');
        }

        // Update the authorization header
        originalRequest.headers.Authorization = `Bearer ${result.accessToken}`;
        
        // Retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        // If refresh fails, redirect to login
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error.response?.data || error);
  }
);

// Example API calls
export const loginUser = (email: string, password: string) =>
  api.post('/auth/login', { email, password });

export const registerUser = (userData: any) =>
  api.post('/auth/register', userData);

export default api;